import { fields, variant } from 'variant';
import type { VariantOf } from 'variant';
import type { DashboardScreenSelector } from './DashboardScreen.js';
import type { BackendScreenSelector } from './BackendScreen.js';

export const ScreenState = variant({
  Home: {},
  SiteSelector: {},
  DashboardScreen: fields<{ selectorType?: DashboardScreenSelector }>(),
  BackendScreen: fields<{ selectorType?: BackendScreenSelector }>(),
});

export type ScreenState = VariantOf<typeof ScreenState>;
